import { Layout } from '@/components/ui/layout';
import { PrivateAdminRoute } from '@/components/organisms/route/admin';
import { Tabs } from '@/components/molecules/tabs';
import { ContextFilesSection } from './contextFiles/index';
import { CityKnowledgeSection } from './cityKnowledge/index';
import { Description, Folder } from '@mui/icons-material';

export default function ChatKnowledgePage() {
  const tabs = [
    {
      label: 'Arquivos de contexto',
      value: 'context-files',
      icon: Folder,
      tab: <ContextFilesSection />,
    },
    {
      label: 'Conhecimento da Cidade',
      value: 'city-knowledge',
      icon: Description,
      tab: <CityKnowledgeSection />,
    },
  ];

  return (
    <PrivateAdminRoute>
      <Layout title="Gestão de Conhecimento do Chat">
        <Tabs tabs={tabs} showBackground={false} />
      </Layout>
    </PrivateAdminRoute>
  );
}
